import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal';
import { tr } from '../utils/locale';

export default class ConfirmationModal extends Component {
    constructor(props) {
        super(props);
        this.modalRef = React.createRef();
    }

    confirm = () => {
        const { confirmCb } = this.props;
        confirmCb();
        this.close();
    };

    close = () => {
        this.modalRef.current.close();
    };

    open = () => {
        this.modalRef.current.open();
    };

    render() {
        const { text, title, defaultIsOpen, testId } = this.props;
        return (
            <Modal
                ref={this.modalRef}
                defaultIsOpen={defaultIsOpen}
                title={title || tr('Beware...')}
                validateBtnProps={{ type: 'important' }}
                validateCb={this.confirm}
                testId={testId}
            >
                <div>{text}</div>
            </Modal>
        );
    }
}

ConfirmationModal.defaultProps = {
    title: '',
    defaultIsOpen: false,
    testId: 'confirmation-modal',
};

ConfirmationModal.propTypes = {
    defaultIsOpen: PropTypes.bool,
    text: PropTypes.string.isRequired,
    title: PropTypes.string,
    confirmCb: PropTypes.func.isRequired,
    testId: PropTypes.string,
};
